(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.vfReady) return;
      root.dataset.vfReady = '1';
      const slides = [...root.querySelectorAll('[data-vf-slide]')];
const dotWrap = root.querySelector('[data-vf-dots]');
      slides.forEach((slide, i) => {
        slide.setAttribute('aria-label', `${i + 1} of ${slides.length}`);
        if (!dotWrap) return;
        const d = document.createElement('button');
        d.type = 'button';
        d.className = 'vf-hero__dot' + (i === 0 ? ' is-active' : '');
        d.dataset.vfDot = String(i);
        d.setAttribute('aria-label', `Go to slide ${i + 1}`);
        if (i === 0) d.setAttribute('aria-current', 'true');
        d.appendChild(document.createElement('span'));
        dotWrap.appendChild(d);
      });
      const dots = [...root.querySelectorAll('[data-vf-dot]')];
      root.querySelectorAll('[data-vf-hot]').forEach((b) => b.addEventListener('click', () => {
        const list = b.closest('.vf-slide__hot')?.querySelector('.vf-slide__products');
        if (list) list.scrollBy({ left: Number(b.dataset.vfHot) * list.clientWidth * 0.75, behavior: 'smooth' });
      }));
      if (slides.length < 2) return;
      let index = 0;
      let timer = null;
      const interval = Number(root.dataset.interval) || 6000;
      const go = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const on = i === index;
          slide.classList.toggle('is-active', on);
          slide.toggleAttribute('inert', !on);
          if (on) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };
      const stop = () => { clearInterval(timer); timer = null; };
      const start = () => {
        if (root.dataset.autoplay !== 'true' || timer) return;
        timer = setInterval(() => go(index + 1), interval);
      };
      root.querySelector('[data-vf-prev]')?.addEventListener('click', () => { stop(); go(index - 1); start(); });
      root.querySelector('[data-vf-next]')?.addEventListener('click', () => { stop(); go(index + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { stop(); go(Number(dot.dataset.vfDot)); start(); }));
      root.addEventListener('focusin', (e) => { if (e.target.matches('a, input')) stop(); });
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
      let x0 = null;
      root.addEventListener('touchstart', (e) => { x0 = e.target.closest('.vf-slide__products') ? null : e.touches[0].clientX; if (x0 === null) stop(); }, { passive: true });
      root.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) { stop(); go(index + (dx < 0 ? 1 : -1)); start(); }
        x0 = null;
      });
      document.addEventListener('shopify:block:select', (e) => {
        const i = slides.findIndex((s) => s.contains(e.target) || s === e.target);
        if (i > -1) { stop(); go(i); }
      });
      start();
    };
    const run = () => document.querySelectorAll('[data-vf-slider]').forEach(init);
    run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
